/* 🤖 this file was generated by svg-to-ts */
export const matIconHourglassFull: {
  name: 'hourglass-full';
  data: string;
} = {
  name: 'hourglass-full',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6z"/></svg>`
};
